import { render } from "./DashboardTV5.vue?vue&type=template&id=6c7c214c"
import script from "./DashboardTV5.vue?vue&type=script&lang=js"
export * from "./DashboardTV5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__